export enum EntityType {
    DRIVE = 'DRIVE',
    FOLDER = 'FOLDER',
    FILE = 'FILE'
}
